
import phone2 from '../assets/images/phone/2.png'
import phone3 from '../assets/images/phone/3.png'
import phone4 from '../assets/images/phone/4.png'
import phone6 from '../assets/images/phone/6.png'
import phone7 from '../assets/images/phone/7.png'
import phone10 from '../assets/images/phone/10.png'
import phone12 from '../assets/images/phone/12.png'


import {
  FiCreditCard,
  FiDollarSign,
  FiRefreshCw,
  FiCoffee,
  FiBell,
  FiShield,
  FiMonitor,
  FiFeather,
  FiEye,
  FiDatabase
} from "react-icons/fi";

export const feature = [
    {
        icon:FiMonitor,
        title:'Tarjeta Digital NFC',
        desc:'Accede y utiliza tu membresía digital desde tu celular sin necesidad de tarjeta física.'
        
    },
    {
        icon:FiFeather,
        title:'Consulta de Saldos',
        desc:'Visualiza tus saldos disponibles en TEBS, Book, Mesas, Poker y Bingo.'
    },
    {
        icon:FiEye,
        title:'Recargas Rápidas',
        desc:'Agrega saldo fácilmente mediante SPEI o tarjetas bancarias en minutos.'
    },
    {
        icon:FiDatabase,
        title:'Data ',
        desc:'Agrega info a',
        active:false
    },
]

export const feature2 = [
    {
        icon: FiCreditCard,
        title: "Tarjeta Digital NFC",
        desc: "Accede y utiliza tu membresía digital desde tu celular sin necesidad de tarjeta física.",
    },
    {
        icon: FiDollarSign,
        title: "Consulta de Saldos",
        desc: "Visualiza tus saldos disponibles en TEBS, Book, Mesas, Poker y Bingo.",
    },
    {
        icon: FiRefreshCw,
        title: "Recargas Rápidas",
        desc: "Agrega saldo fácilmente mediante tarjetas bancarias en minutos.",
    },
];

export const feature3 = [
    {
        icon: FiCoffee,
        title: "Depósitos Seguros",
        desc: "Recarga tu cuenta de manera rápida y confiable utilizando transferencias SPEI.",
    },
    {
        icon: FiBell,
        title: "Notificaciones",
        desc: "Recibe promociones, avisos importantes y novedades en tiempo real.",
    },
    {
        icon: FiShield,
        title: "Perfil Seguro",
        desc: "Gestiona tu información personal y métodos de pago de forma segura.",
    },
];

export const screenshotImg = [
    phone2, phone3, phone4, phone6, phone7, phone10,  phone12
]
